import { FC } from 'react'

import { CompanyRankingSettingsDto, Country } from '../../../../types'
import { CompanySettingsRankingLowTagControl } from './CompanySettingsRankingLowTagControl'
import { CompanySettingsRankingAllowContractChangesControl } from './CompanySettingsRankingAllowContractControl'
import { CompanySettingsRankingEnableRankingControl } from './CompanySettingsRankingEnableRankingControl'
import { CompanySettingsRankingTopTagControl } from './CompanySettingsRankingTopTagControl'

export type CompanySettingsRankingsSettingsFormProps = {
  companyId: string
  country: Country
  settings: CompanyRankingSettingsDto
  disabled: boolean
}

export const CompanySettingsRankingsSettingsForm: FC<CompanySettingsRankingsSettingsFormProps> = ({
  companyId,
  country,
  settings,
  disabled,
}) => {
  return (
    <>
      <CompanySettingsRankingEnableRankingControl companyId={companyId} country={country} settings={settings} disabled={disabled} />
      <CompanySettingsRankingAllowContractChangesControl companyId={companyId} country={country} settings={settings} disabled={disabled} />
      <CompanySettingsRankingLowTagControl companyId={companyId} country={country} settings={settings} disabled={disabled} />
      <CompanySettingsRankingTopTagControl companyId={companyId} country={country} settings={settings} disabled={disabled} />
    </>
  )
}
